import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';
import { Observable } from 'rxjs';
import { Category, Moviesdb,Movies } from './dexiedb/moviedb.service';
import Dexie from 'dexie';

@Injectable({
  providedIn: 'root'
})
export class MovieService {
  domain: any = '';
  username: any = '';
  password: any = '';
  url: any = '';
  Xurl: any;
  Ourl:any;
  OToken:any;
  constructor(public http: HttpClient, public utilService: UtilService) {
    this.Ourl = this.utilService.getOneStreamUrl();
    this.OToken = this.utilService.getOneStreamToken();
  }

  getDataLcal() {
    this.Xurl = this.utilService.getXstreamUrl();
    if (this.Xurl) {
      this.domain = this.utilService.getXstreamUrl();
      this.username = this.utilService.getXstreamUsername();
      this.password = this.utilService.getXstreamPassword();
    }else if(this.Ourl){
      this.domain = this.utilService.getOneStreamUrl();
    }
    else {
      this.domain = this.utilService.getFullUrl();
      this.username = this.utilService.getFullUsername();
      this.password = this.utilService.getFullPassword();
    }
    if(this.Ourl){
      this.url = this.domain + '/play/b2c/v1/';
      return this.url;
    }else{
      this.url = this.domain + '/player_api.php?username=' + this.username + '&password=' + this.password + '&action=';
      return this.url;
    }
  }
  postDataUrl() {
    this.Xurl = this.utilService.getXstreamUrl();
    if (this.Xurl) {
      this.domain = this.utilService.getXstreamUrl();
      this.username = this.utilService.getXstreamUsername();
      this.password = this.utilService.getXstreamPassword();
    } else {
      this.domain = this.utilService.getFullUrl();
      this.username = this.utilService.getFullUsername();
      this.password = this.utilService.getFullPassword();
    }
    const url = this.domain + '/player_api.php';
    return {
      url,
      username: this.username,
      password: this.password
    };
  }

  postApi(action: string, extraParams: any = {}): Observable<any> {
    const authData = this.postDataUrl(); // Get url, username, password
  
    // Assign returned values to instance variables
    this.url = authData.url;
    this.username = authData.username;
    this.password = authData.password;
  
    const body = new URLSearchParams();
    body.set('username', this.username);
    body.set('password', this.password);
    body.set('action', action);
  
    // Dynamically add extraParams
    for (const key in extraParams) {
      if (extraParams[key] !== undefined && extraParams[key] !== null) {
        body.set(key, extraParams[key]);
      }
    }
  
    return this.http.post(this.url, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    });
  }

  postApiData(){
    
    const postData = this.postDataUrl(); // Assuming you need auth for this as well
    const body = new HttpParams()
      .set('username', postData.username)
      .set('password', postData.password)
    console.log(postData,'settings body');
    
    return this.http.post(this.url,body)
  }
  
  
  getRequestType(): 'get' | 'post' {
    return (localStorage.getItem('API') as 'get' | 'post') || 'get';
  }

    async loadCategories(): Promise<Category[]> {
    const playlist = JSON.parse(localStorage.getItem('playlist') || '{}');
    const playlist_id = playlist.id;

  // Check if categories for this playlist already exist
  const existing = await Moviesdb.categories.where('playlist_id').equals(playlist_id).count();
    const count = await Moviesdb.categories.count();
  
    if (existing === 0 ) {
      let categories: Category[] = [];
  
      if (this.OToken) {
        categories = await this.http
          .get<Category[]>(this.postDataUrl() + `categories/vod?token=${this.OToken}`)
          .toPromise();
      } else {
        const reqType = this.getRequestType();
        if (reqType === 'post') {
          categories = await 
            this.postApi('get_vod_categories')
            .toPromise();
        } else {
          categories = await this.http
            .get<Category[]>(this.getDataLcal() + 'get_vod_categories')
            .toPromise();
        }
      }
      const categoriesWithPlaylistId: Category[] = categories.map(c => ({
      category_id: c.category_id,
      category_name: c.category_name,
      playlist_id: playlist_id,
    }));
      await Moviesdb.categories.bulkPut(categoriesWithPlaylistId);
  
    }
    // return await Moviesdb.categories.toArray();
  return await Moviesdb.categories.where('playlist_id').equals(playlist_id).toArray();

  }

  async loadMovies(): Promise<number> {
  const storedPlaylist = localStorage.getItem('playlist');
  if (!storedPlaylist) return 0;

  const playlist = JSON.parse(storedPlaylist);
  const playlist_id = playlist.id;

  const countBefore = await Moviesdb.movies
    .where('playlist_id')
    .equals(playlist_id)
    .count();

  if (countBefore === 0) {
    const MoviesRaw: any[] = await this.selectedCategoryWiseStreamDatas().toPromise();
    console.log('📺 Fetched total live TV streams:', MoviesRaw.length);

    // Step 1: Get favorite stream IDs before mapping
    const favStreamIds = (await Moviesdb.favorites
      .where('playlist_id')
      .equals(playlist_id)
      .toArray()
    ).map(fav => fav.stream_id);

    const mappedMovies: Movies[] = MoviesRaw.map(m => ({
      playlist_id: playlist_id,
      name: m.name,
      stream_id: String(m.stream_id),
      category_id: m.category_id,
      stream_icon: m.stream_icon,
      container_extension: m.container_extension,
      tmdb_id: m.tmdb_id,
      rating: m.rating,
      stream_type: m.stream_type,
      is_favorite: favStreamIds.includes(m.stream_id) 
    }));

    await Moviesdb.movies.bulkPut(mappedMovies);

    const countAfter = await Moviesdb.movies
      .where('playlist_id')
      .equals(playlist_id)
      .count();
    console.log('💾 Stored Movies streams in IndexedDB:', countAfter);
    return countAfter;
  } else {
    console.log('💾 IndexedDB already has Movies streams:', countBefore);
    return countBefore;
  }
}

async getAllMovies(page: number, limit: number): Promise<Movies[]> {
   const storedPlaylist = localStorage.getItem('playlist');
  if (!storedPlaylist) return [];

  const playlist = JSON.parse(storedPlaylist);
  const playlist_id = playlist.id;

  const offset = (page - 1) * limit;
  return await Moviesdb.movies
     .where('playlist_id')
    .equals(playlist_id)
    // .toCollection()      
    .offset(offset)
    .limit(limit)
    .toArray();
  }
//   async getAllMoviesSearch(): Promise<Movies[]> {
//       const storedPlaylist = localStorage.getItem('playlist');
//   if (!storedPlaylist) return [];

//   const playlist = JSON.parse(storedPlaylist);
//   const playlist_id = playlist.id;
//    return await Moviesdb.movies
//       .where('playlist_id')
//       .equals(playlist_id)
//       .toArray();
//   // return await Moviesdb.movies.toArray();
// }
async getAllMoviesSearch(): Promise<Movies[]> {
  const storedPlaylist = localStorage.getItem('playlist');
  if (!storedPlaylist) return [];

  const playlist = JSON.parse(storedPlaylist);
  const playlist_id = playlist.id;

  // Step 1: Get all movies
  const movies = await Moviesdb.movies
    .where('playlist_id')
    .equals(playlist_id)
    .toArray();

  // Step 2: Get all favorite stream_ids for this playlist
  const favorites = await Moviesdb.favorites
    .where('playlist_id')
    .equals(playlist_id)
    .toArray();
  const favoriteIds = favorites.map(f => String(f.stream_id));

  // Step 3: Map is_favorite flag
  return movies.map(movie => ({
    ...movie,
    is_favorite: favoriteIds.includes(movie.stream_id)
  }));
}

  
  async getMoviesByCategory(
  categoryId: string,
  page = 1,
  limit = 50
): Promise<Movies[]> {
  const offset = (page - 1) * limit;

  const storedPlaylist = localStorage.getItem('playlist');
  if (!storedPlaylist) return [];

  const playlist = JSON.parse(storedPlaylist);
  const playlist_id = playlist.id;

  let collection: Dexie.Collection<Movies, any>;

  if (categoryId === 'all') {
    // All movies for current playlist
    collection = Moviesdb.movies
      .where('playlist_id')
      .equals(playlist_id);
  } else {
    // Filter by playlist_id and category_id
    collection = Moviesdb.movies
      .where('[playlist_id+category_id]')
      .equals([playlist_id, categoryId]);
  }

  const results = await collection
    .offset(offset)
    .limit(limit)
    
    .toArray();

  console.log(`Category '${categoryId}' for Playlist '${playlist_id}' → ${results.length} movies`);
  return results;
}

  
async getMoviesByCategoryForSearch(categoryId: string): Promise<Movies[]> {
  const storedPlaylist = localStorage.getItem('playlist');
  if (!storedPlaylist) return [];

  const playlist = JSON.parse(storedPlaylist);
  const playlist_id = playlist.id;

  // Step 1: Get movies by category
  let movies: Movies[] = [];
  if (categoryId === 'all') {
    movies = await Moviesdb.movies
      .where('playlist_id')
      .equals(playlist_id)
      .toArray();
  } else {
    movies = await Moviesdb.movies
      .where('[playlist_id+category_id]')
      .equals([playlist_id, categoryId])
      .toArray();
  }

  // Step 2: Get favorites for this playlist
  const favorites = await Moviesdb.favorites
    .where('playlist_id')
    .equals(playlist_id)
    .toArray();
  const favStreamIds = favorites.map(fav => String(fav.stream_id));

  // Step 3: Mark is_favorite flag
  return movies.map(movie => ({
    ...movie,
    is_favorite: favStreamIds.includes(movie.stream_id)
  }));
}

  



  // ✅ Mark a movie as favorite
  async markAsFavorite(playlistId: number, streamId: string): Promise<void> {
    await Moviesdb.favorites.put({ playlist_id: playlistId, stream_id: streamId });
  }

  // ✅ Unmark a movie as favorite
  async unmarkAsFavorite(playlistId: number, streamId: string): Promise<void> {
    await Moviesdb.favorites.delete([playlistId, streamId]);
  }

  // ✅ Toggle favorite
  // async toggleFavorite(playlistId: number, streamId: string): Promise<void> {
  //   const isFav = await Moviesdb.favorites.get([playlistId, streamId]);
  //   if (isFav) {
  //     await this.unmarkAsFavorite(playlistId, streamId);
  //   } else {
  //     await this.markAsFavorite(playlistId, streamId);
  //   }
  // }

  // ✅ Get all favorite movie stream IDs for a playlist
  async getFavoriteStreamIds(playlistId: number): Promise<string[]> {
    const favs = await Moviesdb.favorites
      .where('playlist_id')
      .equals(playlistId)
      .toArray();

    return favs.map(f => f.stream_id);
  }

  // ✅ Get all favorite movie details for a playlist
  async getFavoriteMovies(playlistId: number): Promise<Movies[]> {
    const streamIds = await this.getFavoriteStreamIds(playlistId);
  
    const movies = await Promise.all(
      streamIds.map(id => Moviesdb.movies.get([playlistId, id]))
    );
  
    return movies.filter((m): m is Movies => !!m); // remove undefined
  }
 async getMoviesById(playlistId: number, ids: string[]): Promise<Movies[]> {
  const allMovies = await Moviesdb.movies
    .where('playlist_id')
    .equals(playlistId)
    .toArray();

  // Filter movies where stream_id matches one of the content_ids
  return allMovies.filter(movie => ids.includes(String(movie.stream_id)));
}


  // ✅ Check if a specific movie is favorite
  async isFavorite(playlistId: number, streamId: string): Promise<boolean> {
    const fav = await Moviesdb.favorites.get([playlistId, streamId]);
    return !!fav;
  }
  
  //Refresh data
  async loadMovieCategories(forceRefresh = false): Promise<Category[]> {
  const playlist = JSON.parse(localStorage.getItem('playlist') || '{}');
  const playlist_id = playlist.id;

  const existing = await Moviesdb.categories.where('playlist_id').equals(playlist_id).count();

  if (existing === 0 || forceRefresh) {
    // 🧼 Delete existing categories if forceRefresh is true
    if (forceRefresh) {
      await Moviesdb.categories.where('playlist_id').equals(playlist_id).delete();
    }

    let categories: Category[] = [];

    if (this.OToken) {
      categories = await this.http
        .get<Category[]>(this.postDataUrl() + `categories/vod?token=${this.OToken}`)
        .toPromise();
    } else {
      const reqType = this.getRequestType();
      if (reqType === 'post') {
        categories = await this.postApi('get_vod_categories').toPromise();
      } else {
        categories = await this.http
          .get<Category[]>(this.getDataLcal() + 'get_vod_categories')
          .toPromise();
      }
    }

    const categoriesWithPlaylistId: Category[] = categories.map(c => ({
      category_id: c.category_id,
      category_name: c.category_name,
      playlist_id: playlist_id,
    }));

    await Moviesdb.categories.bulkPut(categoriesWithPlaylistId);
  }

  return await Moviesdb.categories.where('playlist_id').equals(playlist_id).toArray();
}


async loadMoviesdb(forceRefresh = false): Promise<number> {
  const storedPlaylist = localStorage.getItem('playlist');
  if (!storedPlaylist) return 0;

  const playlist = JSON.parse(storedPlaylist);
  const playlist_id = playlist.id;

  const countBefore = await Moviesdb.movies
    .where('playlist_id')
    .equals(playlist_id)
    .count();

  if (countBefore === 0 || forceRefresh) {
    // 🔸 Get favorite stream IDs before deletion
    const favStreamIds = new Set(
      (await Moviesdb.favorites
        .where('playlist_id')
        .equals(playlist_id)
        .toArray())
        .map(fav => fav.stream_id)
    );

    // 🔸 Fetch fresh movie data
    const MoviesRaw: any[] = await this.selectedCategoryWiseStreamDatas().toPromise();
    console.log('📺 Refreshed/fetched movie streams:', MoviesRaw.length);

    // 🔸 Clear old movie data for this playlist
    await Moviesdb.movies.where('playlist_id').equals(playlist_id).delete();

    // 🔸 Map data and preserve favorites
    const mappedMovies: Movies[] = MoviesRaw.map(m => ({
      playlist_id,
      name: m.name,
      stream_id: String(m.stream_id),
      category_id: m.category_id,
      stream_icon: m.stream_icon,
      container_extension: m.container_extension,
      tmdb_id: m.tmdb_id,
      rating: m.rating,
      stream_type: m.stream_type,
      is_favorite: favStreamIds.has(String(m.stream_id))
    }));

    // 🔸 Store fresh movie data
    await Moviesdb.movies.bulkPut(mappedMovies);

    const countAfter = await Moviesdb.movies
      .where('playlist_id')
      .equals(playlist_id)
      .count();

    console.log('💾 Updated IndexedDB with movies:', countAfter);
    return countAfter;
  } else {
    console.log('✅ Movies already available in IndexedDB:', countBefore);
    return countBefore;
  }
}



  // end dexieDB 
  public getVodCategories() {
    if (this.Ourl) {
      return this.http.get(this.postDataUrl() + `categories/vod?token=${this.OToken}`);
    }
    const reqType = this.getRequestType()
    if (reqType == 'post') {
      return this.postApi('get_vod_categories');
    }else if(reqType == 'get'){    
      return this.http.get(this.getDataLcal() + 'get_vod_categories');
    }
  }
  


  public getVodCategoriess() {
    if(this.Ourl){
      return this.http.get(this.getDataLcal() + `categories/vod?token=${this.OToken}`)
    }
    else{
      return this.http.get( this.getDataLcal() + 'get_vod_categories');
    }
  }
  public selectedCategoryWiseStreamData(id: string) {
    if (this.Ourl) {
      return this.http.get(this.getDataLcal() + 'content/vod/?token=' + this.OToken + '&category_id=' + id);
    }
  
    const reqType = this.getRequestType();
    if (reqType === 'post') {
      return this.postApi('get_vod_streams', { category_id: id });
    }else if(reqType === 'get'){
      return this.http.get(this.getDataLcal() + 'get_vod_streams&category_id=' + id);
    }
  
  }
  
  

  public selectedCategoryWiseStreamDatass(id) {
    if(this.Ourl){
      return this.http.get(this.getDataLcal() + 'content/vod/' + `?token=${this.OToken}&category_id=${id}`)
    }else{
      return this.http.get( this.getDataLcal() + 'get_vod_streams&category_id=' + id);
    }
  }

  public selectedCategoryWiseStreamDatas_(){
    if(this.Ourl){
      return this.http.get(this.getDataLcal() + 'content/vod/' + `?token=${this.OToken}&category_id=all`)
    }else{
    return this.http.get( this.getDataLcal() + 'get_vod_streams');
    }
  }
  public selectedCategoryWiseStreamDatas(){
    if(this.Ourl){
      return this.http.get(this.getDataLcal() + 'content/vod/' + `?token=${this.OToken}&category_id=all`)
    }
    const reqType = this.getRequestType();
    if (reqType === 'post') {
      return this.postApi('get_vod_streams');
    }else if(reqType === 'get'){
      return this.http.get(this.getDataLcal() + 'get_vod_streams');
    }
    
  }



  public getMovieStreamList_() {
    if(this.Ourl){
      return this.http.get(this.getDataLcal() + `content/vod?token=${this.OToken}`)
    }else{
      return this.http.get( this.getDataLcal() + 'get_vod_streams');
    }
  }
  public getMovieStreamList() {
    if(this.Ourl){
      return this.http.get(this.getDataLcal() + `content/vod?token=${this.OToken}`)
    }else{
      const reqType = this.getRequestType();
    if (reqType === 'post') {
      return this.postApi('get_vod_streams');
    }else if(reqType === 'get'){
      return this.http.get(this.getDataLcal() + 'get_vod_streams');
    }
    }
  }
  // public getMovieDeatil(id: any) {
  //   if(this.Ourl){
  //     return this.http.get( this.getDataLcal() + 'content/vod/' + `${id}?token=${this.OToken}`)
  //   }else{
  //     return this.http.get(  this.getDataLcal() + 'get_vod_info&vod_id=' + id ) ;
  //   }
  // }
  public getMovieDeatil(id: any) {
    const baseUrl = this.getDataLcal();
  
    if (this.Ourl) {
      // External API with token
      return this.http.get(`${baseUrl}content/vod/${id}?token=${this.OToken}`);
    } else {
      const reqType = this.getRequestType();
      console.log(reqType);
      
      if (reqType === 'post') {
        // Using dynamic postApi method for POST requests
        return this.postApi('get_vod_info', { vod_id: id });
      }else if(reqType =='get'){

        return this.http.get(`${baseUrl}get_vod_info&vod_id=${id}`);
      }
  
      // Default to GET request
    }
  }
  
  public getStremMovieUrl(id: any, extension: any) {
    this.getDataLcal();
    return ( this.domain + '/movie/' + this.username + '/' + this.password + '/' + id + '.' + extension).replace(environment.cdnurl, '');
    // return (this.domain + '/movie/' + this.username + '/' + this.password + '/' + id + '.' + extension).replace(environment.cdnurl, '');

  }
}

export {Movies}